import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//Components
import DataTable from "react-data-table-component";
import Constants from "../../../common/SupplierConstants";
import { useDispatch, useSelector } from "react-redux";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import StatisticsContainer from "../../../Components/Cards/StatisticsCardContainer";
import MultiColumnFilter from "../../../Components/Filter/MultiColumnFilter";
import ItemService from "../../../services/construction_appCommonService";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import TableActions from "../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";
import BudgetUpdate from "./BudgetUpdate";
import Layout from "../../../Layout/Layout";
import { SearchField } from "../../../Components/formElements/SearchField";
import StickyColumn from "../../../Components/Sticky/StickyColumn";
import BudgetDelete from "./BudgetDelete";
import {
  addBudgetNr,
  getBudgetList,
} from "../../../redux/feature/ap_auto_app/apAutoSlice";
import { useNavigate } from "react-router-dom";
import PaymentHistoryModal from "./PaymentHistoryModal";

const BudgetList = () => {
  const dispatch = useDispatch();
  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  // const [filterShow, setFilterShow] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);

  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const [paymentHistoryModal, setPaymentHistoryModal] = useState(false);
  const [selectedBudget, setSelectedBudget] = useState(null);

  const handlePaymentHistory = (row) => {
    setSelectedBudget(row);
    setPaymentHistoryModal(true);
  };

  // const [getFileViewData, setFileViewData] = useState(null);
  let budgetData = useSelector((state) => state?.apauto?.budget); // User Details from Store
  let entryTable = useSelector((state) => state?.apauto?.budget?.pagination);

  const navigate = useNavigate();
  const tableData = filteredData?.length
    ? filteredData
    : budgetData?.data || [];
  useEffect(() => {
    if (!showStats) {
      setFilteredData(budgetData?.data);
    }
  }, [showStats, budgetData]);
  // eslint-disable-next-line
  const [data, setData] = useState();
  const [modalUpdate, setModalUpdate] = useState(false);

  const [modalDeleteQuotationJob, setModalDeleteQuotationJob] = useState(false);
  const [getEntryListData, setEntryListData] = useState();

  // const handleViewFile = (fileAttachmentId) => {
  //   setFileViewData(fileAttachmentId);
  //   setShowFileViewModal(true);
  // };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const loadQuotationData = async () => {
    setData(budgetData?.data);
  };

  const showUpdateModal = () => {
    setModalUpdate(true);
  };
  const hideUpdateModal = () => {
    setModalUpdate(false);
  };

  const handleEditClick = (row) => {
    dispatch(addBudgetNr(row));
    showUpdateModal("EDIT", row.documentNumber);
  };

  const goBack = () => {
    navigate(-1); // goes to previous page
  };
  // Fetch Filtered Data
  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "Get_Budget_List",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getBudgetList(obj));
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_Budget_List",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getBudgetList(obj));
    setData(budgetData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_Budget_List",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getBudgetList(obj));
    setData(budgetData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_Budget_List",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getBudgetList(obj));
  };

  useEffect(() => {
    loadQuotationData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [budgetData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Get_Budget_List",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getBudgetList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const budgetlist = [
    {
      name: "Budget No",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-new-status">
            {row.documentNumber}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },

    {
      name: "Department",
      selector: (row) => row.budgetDepartment,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-new-status">
            {row.budgetDepartment}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Category",
      selector: (row) => row.category,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.category} </p>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Sub Category",
      selector: (row) => row.budgetSubCategory,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.budgetSubCategory} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "Allocated Amt",
      selector: (row) => row.allocatedAmount,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.allocatedAmount} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Planned Amt",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.plannedAmount} </p>
        </div>
      ),
      selector: (row) => row.plannedAmount,
      sortable: true,
      width: "150px",
    },
    {
      name: "Actual Amt",
      selector: (row) => row.actualAmount,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.actualAmount} </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Remaining Amt",
      selector: (row) => row.remainingAmount,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.remainingAmount} </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Action",
      cell: (row) => (
        <TableActions
          actions={[
            {
              label: "History",
              icon: "bi bi-clock-history",
              iconClass: "text-primary",
              bg: "#e8f0fe",
              onClick: () => handlePaymentHistory(row),
            },
            {
              label: "Edit",
              icon: "bi bi-pencil-square",
              iconClass: "text-success",
              bg: "#e6f7ee",
              onClick: () => handleEditClick(row.documentNumber),
            },
            {
              label: "Delete",
              icon: "bi bi-trash",
              iconClass: "text-danger",
              bg: "#fdeaea",
              onClick: () => deleteQuotaionJob(row),
            },
            {
              label: "More",
              icon: "bi bi-three-dots",
              bg: "#f1f3f5",
              onClick: () => console.log("More", row),
            },
          ]}
        />
      ),
      width: "180px",
    },
  ];

  const columnsForFilter = budgetlist
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));
  //delete

  const deleteQuotaionJob = (data) => {
    setModalDeleteQuotationJob(true);
    setEntryListData(data);
  };

  const hideModal = () => {
    setModalDeleteQuotationJob(false);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">List Of Budget</h2>
                <p className="subText">List Of Budget</p>
                <Col xs={12} md={8} lg={8}>
                  <button className="btn btn-md" onClick={goBack}>
                    <i className="bi bi-arrow-left me-1"></i>
                    Back
                  </button>
                </Col>
              </Col>

              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>
            <hr />

            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>

                <StatisticsContainer
                  api={ItemService.generateCustomerQuery}
                  keyName="type"
                  paginatedList={budgetData.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                  queryName="Get_Budget_List"
                />
              </div>
            )}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LB</span>
                    </Col>
                    <Col xs={6} md={8} lg={8}>
                      <span className="headerTitle">List Budget</span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>
                          <li>
                            <span>
                              <i className="bi bi-download"></i>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <StickyColumn
                          columnIndexes={[2]}
                          leftOffsets={[0, 160]}
                        />
                        <DataTable
                          title=""
                          columns={budgetlist}
                          // data={data}
                          data={tableData}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          onChangeRowsPerPage={handlePerRowsChange}
                          paginationTotalRows={entryTable?.total}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {/* <EntryModel
        show={modalQuotation}
        onHide={() => hideModalStatus()}
        key={modalQuotation ? "open" : "closed"}
      />
      <EntryModel
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
      /> */}
      <BudgetUpdate show={modalUpdate} onHide={() => hideUpdateModal()} />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        // fileid={getFileViewData}
      />
      <BudgetDelete
        show={modalDeleteQuotationJob}
        onHide={() => hideModal()}
        data={getEntryListData}
        // dropdownData={getAccountGroup}
      />
      <PaymentHistoryModal
        show={paymentHistoryModal}
        onHide={() => {
          setPaymentHistoryModal(false);
          setSelectedBudget(null);
        }}
        data={selectedBudget}
      />
    </main>
  );
};

export default BudgetList;
